// Update price on sticky ATC button when subscription is selected
document.querySelectorAll('.rtx-subscription-label').forEach(el => {
  el.addEventListener('click', ev => {
    let priceElSelector = 'data-rtx-onetime-price';
    let stickyAtc = document.querySelector('.add-to-cart.sticky-button .sticky-price');
    let stickyAtcDesktop = document.querySelector('.sticky-product-info .money');
    let price = false;
    if(ev.target.id == 'purchaseTypeSubscription') {
      priceElSelector = 'data-rtx-subscription-price';
    }
    let priceEl = ev.target.parentElement.querySelector(`span[${priceElSelector}]`);
    if(priceEl && priceEl.innerText) {
      const indexOfDollar = priceEl.innerText.indexOf("$");
      if (indexOfDollar !== -1) {
        price = priceEl.innerText.substring(indexOfDollar);
      } else {
        price = priceEl.innerText
      }
    }
    if(price) {
      if(stickyAtc) {
        stickyAtc.innerText = `- ${price}`;
      }
      if(stickyAtcDesktop) {
        stickyAtcDesktop.innerText = price;
      }
    }
  });
});
